export const REPORT_CODES = Object.freeze({
  BALANCE_SHEET: 'BALANCE_SHEET',
  INCOME_STATEMENT: 'INCOME_STATEMENT'
})
